module.exports = __webpack_public_path__ + "img/qx_link_desktop.c19eb91b.png";